"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertCurrencyFieldValueToString = void 0;
const number_1 = require("../utils/number");
const detailed_decimal_1 = require("./detailed-decimal");
const convertCurrencyFieldValueToString = ({ value, locale, currencies, params, }) => {
    var _a, _b, _c, _d, _e, _f;
    if (value === null || value === undefined) {
        return "";
    }
    const asString = (0, detailed_decimal_1.convertNumberToFormatedString)({
        value,
        precision: (_a = params.precision) !== null && _a !== void 0 ? _a : 0,
        decimalSeparator: (_b = params.decimal_separator) !== null && _b !== void 0 ? _b : (0, number_1.getDecimalSeparator)(locale === null || locale === void 0 ? void 0 : locale.value),
        thousandSeparator: params.separator
            ? (_c = params.thousand_separator) !== null && _c !== void 0 ? _c : (0, number_1.getGroupSeparator)(locale === null || locale === void 0 ? void 0 : locale.value)
            : "",
        numberAbbreviation: params.number_abbreviation,
    });
    const currencyCode = (_d = params.currency) !== null && _d !== void 0 ? _d : locale === null || locale === void 0 ? void 0 : locale.currency_code;
    const currencySign = (_f = (_e = currencies.find((currency) => currency.code === currencyCode)) === null || _e === void 0 ? void 0 : _e.sign) !== null && _f !== void 0 ? _f : "";
    if (locale === null || locale === void 0 ? void 0 : locale.currency_before) {
        return `${currencySign}${asString}`.trim();
    }
    return `${asString} ${currencySign}`.trim();
};
exports.convertCurrencyFieldValueToString = convertCurrencyFieldValueToString;
